import React, { useEffect } from 'react';
import {
    Avatar,
    Box,
    CircularProgress,
    Flex,
    HStack,
    Text,
    VStack
} from "@chakra-ui/react";
import useSWR from "swr";
import Error from "./Error";
import ReactGA from "react-ga4";

function Info({ username, setPrivateState, ...props }) {
    const {
        data,
        error,
        isLoading
    } = useSWR("/info?id=" + username)

    useEffect(() => {
        if (data) {
            setPrivateState(data?.is_private ? 1 : 0);
            if (data?.is_private) {
                ReactGA.send({ hitType: "event",
                    eventAction: "view_private",
                    eventLabel: username
                });
            } else{
                ReactGA.send({ hitType: "event",
                    eventAction: "view_public",
                    eventLabel: username
                });
            }
        }
    }, [data, setPrivateState, username]);

    function convertThumb(info) {
        const url = encodeURIComponent(info?.profile_pic_url_hd)
        return `https://ext-api.getghostify.com/media?url=${url}`
    }

    const formatNumber = (num) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        } else {
            return num;
        }
    };

    if (isLoading) return <CircularProgress isIndeterminate color='green.300'/>
    if (error) return <Error/>
    if (data === undefined) return <Error message={"The username you entered does not exist"}/>

    return (
        <HStack m={6} justify={"center"} spacing={2}>
            <Avatar src={convertThumb(data)} size={["lg", "xl", "xl"]} name={data.username}/>
            <Box ml={8}>
                <Text fontSize={["2xl", "2xl", "3xl"]} fontWeight="bold" mr={4} mb={4}>@{data.username}</Text>
                <Flex justify={"space-between"} align="center">
                    <VStack mr={4}>
                        <Text fontSize={"xl"} fontWeight={"bold"}>{formatNumber(data.media_count)}</Text>
                        <Text fontSize={"l"}>posts</Text>
                    </VStack>
                    <VStack mr={4}>
                        <Text fontSize={"xl"} fontWeight={"bold"}>{formatNumber(data.follower_count)}</Text>
                        <Text fontSize={"l"}>followers</Text>
                    </VStack>
                    <VStack mr={4}>
                        <Text fontSize={"xl"} fontWeight={"bold"}>{formatNumber(data.following_count)}</Text>
                        <Text fontSize={"l"}>following</Text>
                    </VStack>
                </Flex>
            </Box>
        </HStack>
    )
}

export default Info
